import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'src/app/modules/core/services/auth.service';
import { DialogService } from 'src/app/modules/core/services/dialog.service';
import { FeedbackModalComponent } from 'src/app/modules/core/components/feedback-modal/feedback-modal.component';
import { FeedbackModalData, PortalExperience, UserType } from 'src/app/modules/core/models/feedback.model';
import { HomeDetails } from 'src/app/modules/core/models/sales.model';
import { ModalComponent } from 'src/app/modules/core/components/modal/modal.component';

import { UnsubscribeOnDestroy } from 'src/app/modules/shared/utilities/unsubscribe-on-destroy';
import { getPageNameFromUrl } from 'src/app/modules/shared/utilities/page-name.utils';

@Injectable({
	providedIn: 'root'
})
export class FeedbackActionsService extends UnsubscribeOnDestroy {

	constructor(
		private authService: AuthService,
		private dialogService: DialogService,
		private router: Router
	) {
		super();
	}

	openFeedbackModal(homeDetails: HomeDetails | null): void {
		if (!homeDetails) {
			return;
		}

		const { salesAgreementId, financialCommunity, lot } = homeDetails;
		const marketId = financialCommunity?.market?.id;
		const financialCommunityId = financialCommunity?.id;

		if (!marketId || !financialCommunityId) {
			return;
		}

		const isPostClose = !!lot?.closeOfEscrow;
		const portalExperience = isPostClose ? PortalExperience.PostClose : PortalExperience.PreClose;
		const userType = this.authService.isRealtorUser() ? UserType.Realtor : UserType.Customer;

		const data: FeedbackModalData = {
			marketId,
			financialCommunityId,
			salesAgreementId,
			portalExperience,
			userType,
			pageUrl: this.router.url,
			pageName: getPageNameFromUrl(this.router.url),
		};

		this.dialogService.openDialog(FeedbackModalComponent, { data, width: '40rem', panelClass: 'cp-feedback-dialog' })
			.afterClosed()
			.pipe(this.takeUntilDestroyed())
			.subscribe(result => {
				if (result === 'submitted') {
					this.dialogService.openDialog(ModalComponent, {
						data: {
							title: 'Feedback Submitted',
							content: 'Thank you for your submission! Your responses have been successfully recorded.',
							contentAlignment: 'center',
							primaryLabel: 'OK',
							secondaryLabel: '',
						}
					});
				} else if (result === 'error') {
					this.dialogService.openDialog(ModalComponent, {
						data: {
							title: 'Submission Failed',
							content: 'Sorry! Something went wrong with the submission. Please wait a moment, refresh, and try again.',
							contentAlignment: 'center',
							primaryLabel: 'OK',
							secondaryLabel: '',
						}
					});
				}
			});
	}
}
